import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { CMSCtx } from 'interfaces/cms'

const selectCmsCtx = createSelector(
  (state: RootState) => state.cms.ctx,
  (cmsCtx: CMSCtx) => cmsCtx
)

export default selectCmsCtx
